import {vpost} from "@/util/post";

export const miuTeacher = {
    list(pageSize = -1, pageCurrent = 1, examineStatus = null, keyword = null) {
        let dto = {
            pageSize,
            pageCurrent,
            examineStatus,
            keyword
        }

        return vpost("/adminMiuTeacher/list", dto)
    },

    detail(id) {
        return vpost("/adminMiuTeacher/detail?id=" + id);
    },
    examine(id, code, errMsg = null) {
        let dto = {
            id,
            code,
            errMsg
        }
        return vpost("/adminMiuTeacher/examine", dto);
    }
}